import { StyleSheet } from 'aphrodite';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		// The page root is a flex row that stretches children to the viewport height; sizing from
		// content instead keeps the white background under everything that scrolls.
		alignSelf: 'flex-start',
		minHeight: '100%',
		boxSizing: 'border-box',
		width: '100%',
		padding: `0 16px`,
		...CssSelectors.allDescendants(
			{
				minHeight: 300,
			},
			'.scroll-view-content'
		),
	},
});
